// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-template-layout_page__zzmwJ {
    page-break-after: always;
    page-break-before: always;
    page-break-inside: avoid;
    width: 100%;
    background: #fbfbfb;
    counter-increment: page;
    position: relative;
}

.pdf-template-layout_page__zzmwJ:after {
    content: 'Page ' counter(page);
    position: absolute;
    bottom: 0;
    right: 15px;
    z-index: 999;
    padding: 2px 12px;
    font-size: 12px;
}

@page {
    size: 1920px 1080px;
    margin: 0;
}

@media print {
    html,
    body {
        width: 1920px;
        height: 1080px;
    }
}

.pdf-template-layout_container__ixdWH {
    padding: 0 47px;
    /*display: flex;*/
    /*flex-direction: column;*/
    min-height: 1080px;
    /*min-height: 100vh;*/
    /*break-inside: avoid;*/
    /*page-break-after: always;*/
    /*page-break-before: always;*/
    /*clear: both;*/
}

.pdf-template-layout_header__lUf21 {
    padding: 40px 0;
    text-align: right;
    display: flex;
    align-items: flex-end;
    grid-gap: 50px;
    justify-content: flex-end;
    height: 100px;
}

.pdf-template-layout_row__BueZZ {
    display: flex;
    flex: 1 1;
}

.pdf-template-layout_rowTop__KMU4T {
    height: calc(100vh - 100px);
    max-height: calc(100vh - 100px);
}

.pdf-template-layout_left__94wBd {
    width: 600px;
    display: flex;
    flex-direction: column;
    grid-gap: 14px;
}

.pdf-template-layout_left__94wBd.pdf-template-layout_leftSmaller__QWp5U {
    width: 400px;
}

.pdf-template-layout_leftCenter__VClWH {
    margin: auto 0;
}

.pdf-template-layout_leftTop__7ucev {
    height: 30%;
}

.pdf-template-layout_leftBottom__PNKAX {
    min-height: 30%;
    display: flex;
    align-items: flex-end;
    margin: auto auto auto 0;
}

.pdf-template-layout_comment__oV-wk {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
}

.pdf-template-layout_right__V9lRY {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
}

.pdf-template-layout_right__V9lRY.pdf-template-layout_alignLeft__KPEma {
    justify-content: flex-start;
    align-items: flex-start;
}

.pdf-template-layout_bottomRight__VLv9t {
    margin: auto 0 auto auto;
}

.pdf-template-layout_graph__utFfk {
    text-align: right;
    margin: 0 0 auto auto;
    max-height: 90%;
    display: flex;
    padding: 80px 80px 20px;
}

.pdf-template-layout_right__V9lRY.pdf-template-layout_alignLeft__KPEma .pdf-template-layout_graph__utFfk {
    margin: 0;
    padding: 0;
    text-align: left;
}

.pdf-template-layout_graph__utFfk svg {
    max-height: 100%;
    height: auto;
    width: auto;
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/PdfTemplate/pdf-template-layout.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;;QAEI,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":[".page {\n    page-break-after: always;\n    page-break-before: always;\n    page-break-inside: avoid;\n    width: 100%;\n    background: #fbfbfb;\n    counter-increment: page;\n    position: relative;\n}\n\n.page:after {\n    content: 'Page ' counter(page);\n    position: absolute;\n    bottom: 0;\n    right: 15px;\n    z-index: 999;\n    padding: 2px 12px;\n    font-size: 12px;\n}\n\n@page {\n    size: 1920px 1080px;\n    margin: 0;\n}\n\n@media print {\n    html,\n    body {\n        width: 1920px;\n        height: 1080px;\n    }\n}\n\n.container {\n    padding: 0 47px;\n    /*display: flex;*/\n    /*flex-direction: column;*/\n    min-height: 1080px;\n    /*min-height: 100vh;*/\n    /*break-inside: avoid;*/\n    /*page-break-after: always;*/\n    /*page-break-before: always;*/\n    /*clear: both;*/\n}\n\n.header {\n    padding: 40px 0;\n    text-align: right;\n    display: flex;\n    align-items: flex-end;\n    grid-gap: 50px;\n    justify-content: flex-end;\n    height: 100px;\n}\n\n.row {\n    display: flex;\n    flex: 1;\n}\n\n.rowTop {\n    height: calc(100vh - 100px);\n    max-height: calc(100vh - 100px);\n}\n\n.left {\n    width: 600px;\n    display: flex;\n    flex-direction: column;\n    grid-gap: 14px;\n}\n\n.left.leftSmaller {\n    width: 400px;\n}\n\n.leftCenter {\n    margin: auto 0;\n}\n\n.leftTop {\n    height: 30%;\n}\n\n.leftBottom {\n    min-height: 30%;\n    display: flex;\n    align-items: flex-end;\n    margin: auto auto auto 0;\n}\n\n.comment {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 300;\n}\n\n.right {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.right.alignLeft {\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.bottomRight {\n    margin: auto 0 auto auto;\n}\n\n.graph {\n    text-align: right;\n    margin: 0 0 auto auto;\n    max-height: 90%;\n    display: flex;\n    padding: 80px 80px 20px;\n}\n\n.right.alignLeft .graph {\n    margin: 0;\n    padding: 0;\n    text-align: left;\n}\n\n.graph svg {\n    max-height: 100%;\n    height: auto;\n    width: auto;\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `pdf-template-layout_page__zzmwJ`,
	"container": `pdf-template-layout_container__ixdWH`,
	"header": `pdf-template-layout_header__lUf21`,
	"row": `pdf-template-layout_row__BueZZ`,
	"rowTop": `pdf-template-layout_rowTop__KMU4T`,
	"left": `pdf-template-layout_left__94wBd`,
	"leftSmaller": `pdf-template-layout_leftSmaller__QWp5U`,
	"leftCenter": `pdf-template-layout_leftCenter__VClWH`,
	"leftTop": `pdf-template-layout_leftTop__7ucev`,
	"leftBottom": `pdf-template-layout_leftBottom__PNKAX`,
	"comment": `pdf-template-layout_comment__oV-wk`,
	"right": `pdf-template-layout_right__V9lRY`,
	"alignLeft": `pdf-template-layout_alignLeft__KPEma`,
	"bottomRight": `pdf-template-layout_bottomRight__VLv9t`,
	"graph": `pdf-template-layout_graph__utFfk`
};
export default ___CSS_LOADER_EXPORT___;
